// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-tabs-items[data-v-77c36440] {\r\n  display: grid !important;\n}\n.v-tabs-items[data-v-77c36440] .v-window__container {\r\n  height: 100%;\n}\n.v-tabs-items[data-v-77c36440] .v-window-item {\r\n  height: 100%;\n}\n.v-application .text-overline[data-v-77c36440] {\r\n  line-height: 0 !important;\n}\r\n/* .col {\r\n  border: solid 1px orange;\r\n} */\r\n", ""]);
// Exports
module.exports = exports;
